import { cloneElement } from 'react';
import { Button, DialogActions, DialogContent } from '@mui/material';
import { formikForm } from '../../hoc';

function FormDialog({
  formContent, formAction, table, formik,
}) {
  return (
    <>
      <DialogContent dividers sx={{ padding: table ?? '10px 24px', overflow: 'auto', maxHeight: '50vh' }}>
        {formContent && cloneElement(formContent, { formik })}
      </DialogContent>
      {formAction && (
        <DialogActions sx={{ m: 1, overflow: 'visible' }}>
          {typeof formAction === 'string' ? (
            <Button
              mt={1}
              color="primary"
              variant="contained"
              type="submit"
              size="medium"
            >
              {formAction}
            </Button>
          ) : (
            Array.isArray(formAction) && formAction.map((action, index) => (
              <Button
                key={index}
                mt={1}
                variant={action.variant || 'contained'}
                type={action.type || 'button'}
                size={action.size || 'medium'}
                onClick={action.onClick}
              >
                {action.label}
              </Button>
            ))
          )}
        </DialogActions>
      )}
    </>
  );
}

export default formikForm(FormDialog);
